<div class="filter-group" data-group-visibility-id="showMyJewelFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showMyJewelFilters" (click)="filter.groupVisibility.showMyJewelFilters = !filter.groupVisibility.showMyJewelFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Jewels" [activeRules]="activeSpecialRules.jewelExceptions">
          Rules with a <span class="equipment-filter-from-preset-example">gold line</span> to the left were automatically generated from your Class or Progress Preset, and might get changed along with presets.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showMyJewelFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showMyJewelFilters">

      @for (jewel of filter.jewelFilters; track $index) {
        <app-jewel-filter
          [jewel]="jewel"
          [index]="$index"
          (remove)="removeJewelType($event)">
        </app-jewel-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addJewelType()">
          Add Jewel Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
